'use strict';

/* globals angular */
require('./processing');
require('./dataStores');

const ManagerController = require('./ManagerController');
const ManagerRoutes = require('./ManagerRoutes');
const ManagerService = require('./ManagerService');
const SpinnerDirective = require('./directives/SpinnerDirective');
const ScrollTopDirective = require('./directives/ScrollTopDirective');
const DataExportService = require('../dash/map/services/DataExportService');


angular.module('manager', [
  'manager.managerStore',
  'manager.processingJobs',
  'manager.processingJobs.dialog'
])

// Routing
.config(ManagerRoutes)

// Main Controller
.controller('ManagerController', ManagerController)

.service('DataExportService', DataExportService)

// Directives
.directive('managerSpinner', SpinnerDirective)
.directive('scrollToTop', ScrollTopDirective)

// Flux Actions and Store
.factory('ManagerActions', require('./ManagerActions'))

// Services
.service('ManagerService', ManagerService);



// WEBPACK FOOTER //
// ./src/app/manager/index.js